const schoolCountries = [
  { value: "4", displayValue: "Afghanistan" },
  { value: "248", displayValue: "Åland Islands" },
  { value: "8", displayValue: "Albania" },
  { value: "12", displayValue: "Algeria" },
  { value: "16", displayValue: "American Samoa" },
  { value: "20", displayValue: "Andorra" },
  { value: "24", displayValue: "Angola" },
  { value: "660", displayValue: "Anguilla" },
  { value: "10", displayValue: "Antarctica" },
  { value: "28", displayValue: "Antigua and Barbuda" },
  { value: "32", displayValue: "Argentina" },
  { value: "51", displayValue: "Armenia" },
  { value: "533", displayValue: "Aruba" },
  { value: "36", displayValue: "Australia" },
  { value: "40", displayValue: "Austria" },
  { value: "31", displayValue: "Azerbaijan" },
  { value: "44", displayValue: "Bahamas" },
  { value: "48", displayValue: "Bahrain" },
  { value: "50", displayValue: "Bangladesh" },
  { value: "52", displayValue: "Barbados" },
  { value: "112", displayValue: "Belarus" },
  { value: "56", displayValue: "Belgium" },
  { value: "84", displayValue: "Belize" },
  { value: "204", displayValue: "Benin" },
  { value: "60", displayValue: "Bermuda" },
  { value: "64", displayValue: "Bhutan" },
  { value: "68", displayValue: "Bolivia" },
  { value: "70", displayValue: "Bosnia and Herzegovina" },
  { value: "72", displayValue: "Botswana" },
  { value: "74", displayValue: "Bouvet Island" },
  { value: "76", displayValue: "Brazil" },
  { value: "86", displayValue: "British Indian Ocean Territory" },
  { value: "96", displayValue: "Brunei Darussalam" },
  { value: "100", displayValue: "Bulgaria" },
  { value: "854", displayValue: "Burkina Faso" },
  { value: "108", displayValue: "Burundi" },
  { value: "116", displayValue: "Cambodia" },
  { value: "120", displayValue: "Cameroon" },
  { value: "124", displayValue: "Canada" },
  { value: "132", displayValue: "Cape Verde" },
  { value: "535", displayValue: "Caribbean Netherlands" },
  { value: "136", displayValue: "Cayman Islands" },
  { value: "140", displayValue: "Central African Republic" },
  { value: "140", displayValue: "Chad" },
  { value: "152", displayValue: "Chile" },
  { value: "156", displayValue: "China" },
  { value: "162", displayValue: "Christmas Island" },
  { value: "166", displayValue: "Cocos (Keeling) Islands" },
  { value: "170", displayValue: "Colombia" },
  { value: "174", displayValue: "Comoros" },
  { value: "178", displayValue: "Congo" },
  { value: "180", displayValue: "Congo, Democratic Republic of the" },
  { value: "184", displayValue: "Cook Islands" },
  { value: "188", displayValue: "Costa Rica" },
  { value: "384", displayValue: "Côte dIvoire" },
  { value: "191", displayValue: "Croatia" },
  { value: "192", displayValue: "Cuba" },
  { value: "531", displayValue: "Curaçao" },
  { value: "196", displayValue: "Cyprus" },
  { value: "203", displayValue: "Czech Republic" },
  { value: "208", displayValue: "Denmark" },
  { value: "262", displayValue: "Djibouti" },
  { value: "212", displayValue: "Dominica" },
  { value: "214", displayValue: "Dominican Republic" },
  { value: "218", displayValue: "Ecuador" },
  { value: "818", displayValue: "Egypt" },
  { value: "222", displayValue: "El Salvador" },
  { value: "226", displayValue: "Equatorial Guinea" },
  { value: "232", displayValue: "Eritrea" },
  { value: "233", displayValue: "Estonia" },
  { value: "231", displayValue: "Ethiopia" },
  { value: "238", displayValue: "Falkland Islands (Malvinas)" },
  { value: "234", displayValue: "Faroe Islands" },
  { value: "242", displayValue: "Fiji" },
  { value: "246", displayValue: "Finland" },
  { value: "250", displayValue: "France" },
  { value: "254", displayValue: "French Guiana" },
  { value: "258", displayValue: "French Polynesia" },
  { value: "260", displayValue: "French Southern Territories" },
  { value: "266", displayValue: "Gabon" },
  { value: "270", displayValue: "Gambia" },
  { value: "268", displayValue: "Georgia" },
  { value: "276", displayValue: "Germany" },
  { value: "288", displayValue: "Ghana" },
  { value: "292", displayValue: "Gibraltar" },
  { value: "300", displayValue: "Greece" },
  { value: "304", displayValue: "Greenland" },
  { value: "308", displayValue: "Grenada" },
  { value: "312", displayValue: "Guadeloupe" },
  { value: "316", displayValue: "Guam" },
  { value: "320", displayValue: "Guatemala" },
  { value: "831", displayValue: "Guernsey" },
  { value: "324", displayValue: "Guinea" },
  { value: "624", displayValue: "Guinea-Bissau" },
  { value: "328", displayValue: "Guyana" },
  { value: "332", displayValue: "Haiti" },
  { value: "334", displayValue: "Heard Island and McDonald Islands" },
  { value: "340", displayValue: "Honduras" },
  { value: "344", displayValue: "Hong Kong" },
  { value: "348", displayValue: "Hungary" },
  { value: "352", displayValue: "Iceland" },
  { value: "356", displayValue: "India" },
  { value: "360", displayValue: "Indonesia" },
  { value: "364", displayValue: "Iran" },
  { value: "368", displayValue: "Iraq" },
  { value: "372", displayValue: "Ireland" },
  { value: "833", displayValue: "Isle of Man" },
  { value: "376", displayValue: "Israel" },
  { value: "380", displayValue: "Italy" },
  { value: "388", displayValue: "Jamaica" },
  { value: "392", displayValue: "Japan" },
  { value: "832", displayValue: "Jersey" },
  { value: "400", displayValue: "Jordan" },
  { value: "398", displayValue: "Kazakhstan" },
  { value: "404", displayValue: "Kenya" },
  { value: "296", displayValue: "Kiribati" },
  {
    value: "408",
    displayValue: "Korea, Democratic Peoples Republic of (North)",
  },
  { value: "410", displayValue: "Korea, Republic of (South)" },
  { value: "414", displayValue: "Kuwait" },
  { value: "417", displayValue: "Kyrgyzstan" },
  { value: "418", displayValue: "Laos" },
  { value: "428", displayValue: "Latvia" },
  { value: "422", displayValue: "Lebanon" },
  { value: "426", displayValue: "Lesotho" },
  { value: "430", displayValue: "Liberia" },
  { value: "434", displayValue: "Libya" },
  { value: "438", displayValue: "Liechtenstein" },
  { value: "440", displayValue: "Lithuania" },
  { value: "442", displayValue: "Luxembourg" },
  { value: "446", displayValue: "Macao" },
  { value: "807", displayValue: "Macedonia, Republic of" },
  { value: "450", displayValue: "Madagascar" },
  { value: "454", displayValue: "Malawi" },
  { value: "458", displayValue: "Malaysia" },
  { value: "462", displayValue: "Maldives" },
  { value: "466", displayValue: "Mali" },
  { value: "470", displayValue: "Malta" },
  { value: "584", displayValue: "Marshall Islands" },
  { value: "474", displayValue: "Martinique" },
  { value: "478", displayValue: "Mauritania" },
  { value: "480", displayValue: "Mauritius" },
  { value: "175", displayValue: "Mayotte" },
  { value: "484", displayValue: "Mexico" },
  { value: "583", displayValue: "Micronesia, Federated States of" },
  { value: "498", displayValue: "Moldova" },
  { value: "492", displayValue: "Monaco" },
  { value: "496", displayValue: "Mongolia" },
  { value: "499", displayValue: "Montenegro" },
  { value: "500", displayValue: "Montserrat" },
  { value: "504", displayValue: "Morroco" },
  { value: "508", displayValue: "Mozambique" },
  { value: "104", displayValue: "Myanmar" },
  { value: "516", displayValue: "Namibia" },
  { value: "520", displayValue: "Nauru" },
  { value: "524", displayValue: "Nepal" },
  { value: "528", displayValue: "Netherlands" },
  { value: "540", displayValue: "New Caledonia" },
  { value: "554", displayValue: "New Zealand" },
  { value: "558", displayValue: "Nicaragua" },
  { value: "562", displayValue: "Niger" },
  { value: "566", displayValue: "Nigeria" },
  { value: "570", displayValue: "Niue" },
  { value: "574", displayValue: "Norfolk Island" },
  { value: "580", displayValue: "Northern Mariana Islands" },
  { value: "578", displayValue: "Norway" },
  { value: "512", displayValue: "Oman" },
  { value: "586", displayValue: "Pakistan" },
  { value: "585", displayValue: "Palau" },
  { value: "275", displayValue: "Palestinian Territories" },
  { value: "591", displayValue: "Panama" },
  { value: "598", displayValue: "Papua New Guinea" },
  { value: "600", displayValue: "Paraguay" },
  { value: "604", displayValue: "Peru" },
  { value: "608", displayValue: "Philippines" },
  { value: "612", displayValue: "Pitcairn Islands" },
  { value: "616", displayValue: "Poland" },
  { value: "620", displayValue: "Portugal" },
  { value: "630", displayValue: "Puerto Rico" },
  { value: "634", displayValue: "Qatar" },
  { value: "638", displayValue: "Réunion" },
  { value: "642", displayValue: "Romania" },
  { value: "643", displayValue: "Russia" },
  { value: "646", displayValue: "Rwanda" },
  { value: "652", displayValue: "Saint Barthélemy" },
  {
    value: "654",
    displayValue: "Saint Helena, Ascension and Tristan da Cunha",
  },
  { value: "659", displayValue: "Saint Kitts and Nevis" },
  { value: "662", displayValue: "Saint Lucia" },
  { value: "663", displayValue: "Saint Martin (French part)" },
  { value: "666", displayValue: "Saint Pierre and Miquelon" },
  { value: "670", displayValue: "Saint Vincent and the Grenadines" },
  { value: "882", displayValue: "Samoa" },
  { value: "674", displayValue: "San Marino" },
  { value: "678", displayValue: "Sao Tome and Principe" },
  { value: "682", displayValue: "Saudi Arabia" },
  { value: "686", displayValue: "Senegal" },
  { value: "688", displayValue: "Serbia" },
  { value: "690", displayValue: "Seychelles" },
  { value: "694", displayValue: "Sierra Leone" },
  { value: "702", displayValue: "Singapore" },
  { value: "534", displayValue: "Sint Maarten (Dutch part)" },
  { value: "703", displayValue: "Slovakia" },
  { value: "705", displayValue: "Slovenia" },
  { value: "90", displayValue: "Solomon Islands" },
  { value: "706", displayValue: "Somalia" },
  { value: "710", displayValue: "South Africa" },
  {
    value: "239",
    displayValue: "South Georgia and the South Sandwich Islands",
  },
  { value: "728", displayValue: "South Sudan" },
  { value: "724", displayValue: "Spain" },
  { value: "144", displayValue: "Sri Lanka" },
  { value: "729", displayValue: "Sudan" },
  { value: "740", displayValue: "Suriname" },
  { value: "744", displayValue: "Svalbard and Jan Mayen" },
  { value: "748", displayValue: "Swaziland" },
  { value: "752", displayValue: "Sweden" },
  { value: "756", displayValue: "Switzerland" },
  { value: "760", displayValue: "Syria" },
  { value: "158", displayValue: "Taiwan" },
  { value: "762", displayValue: "Tajikistan" },
  { value: "834", displayValue: "Tanzania" },
  { value: "764", displayValue: "Thailand" },
  { value: "626", displayValue: "Timor-Leste" },
  { value: "768", displayValue: "Togo" },
  { value: "772", displayValue: "Tokelau" },
  { value: "776", displayValue: "Tonga" },
  { value: "780", displayValue: "Trinidad and Tobago" },
  { value: "788", displayValue: "Tunisia" },
  { value: "792", displayValue: "Turkey" },
  { value: "795", displayValue: "Turkmenistan" },
  { value: "796", displayValue: "Turks and Caicos Islands" },
  { value: "798", displayValue: "Tuvalu" },
  { value: "800", displayValue: "Uganda" },
  { value: "804", displayValue: "Ukraine" },
  { value: "784", displayValue: "United Arab Emirates" },
  { value: "826", displayValue: "United Kingdom" },
  { value: "581", displayValue: "United States Minor Outlying Islands" },
  { value: "840", displayValue: "United States of America" },
  { value: "858", displayValue: "Uruguay" },
  { value: "860", displayValue: "Uzbekistan" },
  { value: "548", displayValue: "Vanuatu" },
  { value: "336", displayValue: "Vatican City" },
  { value: "862", displayValue: "Venezuela" },
  { value: "704", displayValue: "Viet Nam" },
  { value: "92", displayValue: "Virgin Islands, British" },
  { value: "850", displayValue: "Virgin Islands, U,S," },
  { value: "876", displayValue: "Wallis and Futuna" },
  { value: "732", displayValue: "Western Sahara" },
  { value: "887", displayValue: "Yemen" },
  { value: "894", displayValue: "Zambia" },
  { value: "716", displayValue: "Zimbabwe" },
];

export default schoolCountries;
